var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showGroup)?_c('payout-form-group',[_c('div',{staticClass:"form-control-space"},[_c('payout-destination-currency-conversion-notice',{attrs:{"source-currency":_vm.sourceCurrency,"dest-currency":_vm.destCurrency}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }